import { defineStore } from "pinia";

/**
 * Normalize auth/session API payloads into the user shape legacy components expect.
 * Accepts both login and getCurrent response `data` objects (user + sibling fields).
 */
export function normalizeUser(payload = {}) {
	if (!payload?.user) {
		return null;
	}

	return {
		...payload.user,
		config: payload.config ?? payload.user.config ?? {},
		settings: payload.settings ?? payload.user.settings ?? {},
		trackingDomains: payload.trackingDomains ?? payload.user.trackingDomains,
		postbackDomains: payload.postbackDomains ?? payload.user.postbackDomains,
		invoiceNotes: payload.invoiceNotes ?? payload.user.invoiceNotes,
		accountingProvider: payload.accountingProvider ?? payload.user.accountingProvider,
		offerConfig: payload.offerConfig ?? payload.user.offerConfig,
	};
}

export const useAppStore = defineStore("app", {
	state: () => ({
		toggledSidebar: false,
		authToken: null,
		user: null,
	}),

	actions: {
		toggle(key) {
			this[key] = !this[key];
		},

		setUser(payload) {
			if (payload?.user) {
				const user = normalizeUser(payload);
				this.user = user;
				this.authToken = payload.token;

				localStorage.setItem("user", JSON.stringify(user));
				localStorage.setItem("authToken", payload.token);
			} else {
				this.user = null;
				this.authToken = null;

				localStorage.removeItem("user");
				localStorage.removeItem("authToken");
			}

			return this.user;
		},

		closeSidebar() {
			this.toggledSidebar = false;
			return this.toggledSidebar;
		},
	},
});
